import axios from "axios"

function request(method, path, data, params, signal) {
  return axios({ method, url: "/api/pos" + path, data, params, signal,
    timeout: path.startsWith("/badges/import") && method === "post" ? 300000 : path.startsWith("/catalog/import") || path.startsWith("/catalog/studio-mapping") || path.startsWith("/catalog/groups") || path === "/vouchers/tac-inspection" ? 180000 : 20000,
    headers: { Authorization: localStorage.getItem("token") } }).then(response => response.data)
}
const part = value => encodeURIComponent(value)
export function operationId() {
  const bytes = new Uint8Array(16)
  window.crypto.getRandomValues(bytes)
  return Array.from(bytes, byte => byte.toString(16).padStart(2, "0")).join("")
}
export function errorMessage(error) {
  if (error.response && [401, 403].includes(error.response.status)) return "Deine Sitzung oder Kassenberechtigung ist nicht mehr gültig."
  return error.response && error.response.data && error.response.data.message || "Die Verbindung zur Kasse ist fehlgeschlagen. Bitte erneut versuchen."
}
export default {
  context: () => request("get", "/context"),
  accountSettings: studioId => request("get", "/settings/accounts/" + part(studioId)),
  saveAccountSettings: (studioId, body) => request("put", "/settings/accounts/" + part(studioId), body),
  customer: id => request("get", "/customers/" + part(id)),
  customerAccount: id => request("get", "/customers/" + part(id) + "/account"),
  uploadPicture: file => { const form = new FormData(); form.append("file", file); return request("post", "/catalog/picture", form) },
  lookupCustomers: (search, signal) => request("get", "/customers", null, { search }, signal),
  customerByBadge: (uidHex, studioId, signal) => request("post", "/customers/by-badge", { uidHex, studioId }, null, signal),
  badgeImportStatus: () => request("get", "/badges/import"),
  previewBadgeImport: () => request("post", "/badges/import-preview"),
  importBadges: body => request("post", "/badges/import", body),
  customerInvoices: userId => request("get", "/customers/" + part(userId) + "/invoices"),
  catalog: params => request("get", "/catalog", null, params),
  productEditor: id => request("get", "/catalog/product-editor", null, id ? { id } : {}),
  tacSuggestions: (search, signal, offset = 0) => request("get", "/catalog/tac-suggestions", null, { search, offset }, signal),
  tacSuggestion: key => request("get", "/catalog/tac-suggestions/" + part(key)),
  tacSelection: keys => request("post", "/catalog/tac-selection", { keys }),
  saveProduct: (id, body) => id ? request("put", "/catalog/products/" + part(id), body) : request("post", "/catalog/products", body),
  clearCatalogPreview: () => request("get", "/catalog/clear-preview"),
  clearCatalog: body => request("post", "/catalog/clear", body),
  catalogGroups: params => request("get", "/catalog/groups", null, params),
  saveCatalogGroups: body => request("post", "/catalog/groups", body),
  previewImport: document => request("post", "/catalog/import-preview", { document }),
  importCatalog: body => request("post", "/catalog/import", body),
  previewStudioMapping: () => request("get", "/catalog/studio-mapping/preview"),
  applyStudioMapping: body => request("post", "/catalog/studio-mapping", body),
  saveArticle: (id, body) => request("put", "/catalog/articles/" + part(id), body),
  orders: params => request("get", "/orders", null, params),
  order: id => request("get", "/orders/" + part(id)),
  saveOrder: body => request("post", "/orders", body),
  cancelOrder: (id, revision) => request("post", "/orders/" + part(id) + "/cancel", { revision }),
  invoice: (agreementId, invoiceId) => request("get", "/invoices/" + part(agreementId) + "/" + part(invoiceId)),
  vouchers: params => request("get", "/vouchers", null, params),
  inspectTacVouchers: () => request("get", "/vouchers/tac-inspection"),
  report: studioId => request("get", "/report", null, { studioId }),
  terminals: studioId => request("get", "/terminals", null, { studioId }),
  connectTerminal: (id, body) => request("post", "/terminals/" + part(id) + "/connect", body),
  disconnectTerminal: (id, socketId) => request("post", "/terminals/" + part(id) + "/disconnect", { socketId }),
  inbox: (id, socketId) => request("get", "/terminals/" + part(id) + "/inbox", null, { socketId }),
  send: body => request("post", "/handoffs", body),
  handoff: id => request("get", "/handoffs/" + part(id)),
  handoffContent: (id, socketId) => request("get", "/handoffs/" + part(id) + "/content", null, { socketId }),
  acknowledge: (id, socketId, status) => request("post", "/handoffs/" + part(id) + "/acknowledge", { socketId, status }),
}
